import { Model } from "servisofts-model";
export var PARAMS = {};
export var init = function (props) {
    if (!Model.usuario) {
        console.error("Roles_permisos required Model.usuario;");
        return;
    }
};
